<dsd-container>
  <h2 class="dsd-t-4">{{ 'caad.modifier.coordonnees.libelle.adresseprincipale' | translate }}</h2>
  <p class="dsd-mb-0 adresse-texte">{{ adresse }}</p>
</dsd-container>
